import { Component, OnInit } from '@angular/core';
import {environment} from '../../../environments/environment';
import {Router} from '@angular/router';

@Component({
  selector: 'app-forward',
  templateUrl: './forward.component.html',
  styleUrls: ['./forward.component.scss']
})
export class ForwardComponent implements OnInit {
  private env = environment;

  constructor(private router: Router) { }

  ngOnInit() {
    this.router.navigate([this.env.defaultLogin]);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/forward/forward.component.ts